<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Log actiuni"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="false"
              />
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent.native="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
                <el-form-item label='Tip actiune' >
                  <el-select class='full-width' v-model='Filters.Actiuni' filterable >
                    <el-option label="Toate" value="-1"></el-option>
                    <el-option v-for='item in Info.actiuni' :key="'actiuni' + item.Actiune" :label='item.Nume' :value='item.Actiune'></el-option>
                  </el-select>
                </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Utilizator">
                <el-select class="full-width" v-model="Filters.IdUser" filterable>
                  <el-option label="Oricare" value="-1"></el-option>
                  <el-option
                    v-for="item in Info.utilizatori"
                    :key="'utilizatori' + item.IdUser"
                    :label="item.Nume"
                    :value="item.IdUser"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Numar inmatriculare">
                <el-input v-model="Filters.Numar" />
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label='Interval'>
                <br>
                <el-date-picker                            
                    v-model="Filters.Data"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="Data inceput"
                    end-placeholder="Data sfarsit"
                    :picker-options="datePickerOptions"
                    format="dd/MM/yyyy" value-format="yyyy-MM-dd" >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-button
                type="primary"
                native-type="submit"
                @click="refresh_info()"
              >
                Aplica
              </el-button>
              <el-button type="danger" native-type="submit" @click="reset()">
                Reseteaza
              </el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table el-table :data="Results">
      <el-table-column prop="Id" width = "70px" label="#"></el-table-column>
      <el-table-column prop="IdDeviz" label="# deviz" width = "120px"/>
      <el-table-column prop="Actiune" label="Actiune" width= "400px"></el-table-column>
      <el-table-column prop="NumeUtilizator" label="Nume utilizator" width= "250px"></el-table-column>
      <el-table-column label="Data" width = "300px">
        <template slot-scope="scope">
          {{ scope.row.DataEveniment | DataOraFaraSec() }}
        </template> 
      </el-table-column>
      
     
      <el-table-column prop="Descriere" label="Descriere"  ></el-table-column>
    </el-table>

    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      Results: [],
      base_url: "",
      Info: {
        clienti: [],
      },
      Filters: {
        IdUser: "-1",
        Actiuni: "-1",
        IdDeviz: "-1",
        Data: [],
        Numar: "",
      },
      OrderBy: {'Id': 'DESC'},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async get_info() {
      var response = await this.post("admin/actiuni/get_info");
      this.Info.actiuni = response.actiuni;
      this.Info.utilizatori = response.utilizatori;
      // if (this.Filters.IdUser.length > 0)
      //   this.Filters.IdUser = this.Info.utilizatori[0].Id;
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("admin/actiuni/index", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });


      response.Results.forEach((obj)=>{
        let currentObject = {}
        let jsonToParse = false;
        let descArray = []
        for (let key in obj) {
          if (key !== 'Descriere') {
            if(key == 'Actiune' && obj[key] == 'modificare_deviz_mecanici'){
              jsonToParse = true;
            }
            currentObject[key] = obj[key];
          }else if(key == 'Descriere' && jsonToParse){
            const descriere = JSON.parse(obj['Descriere']);
            descriere.forEach((desc)=>{
              let descModificata = desc.Modificare + " (IdProdus:" + desc.IdProdus + ")" 
              descArray.push(descModificata);

            })
          }
          
        }

        if(!jsonToParse){
          this.Results.push(obj);
        }else{
            descArray.forEach((desc)=>{
              let newObject = {...currentObject};
              newObject['Descriere'] = desc

              this.Results.push(newObject);
            })
        }
      })
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("actiuni");
    },
    reset() {
      this.Filters = {
        IdUser: "-1",
        Actiuni: "-1",
        IdDeviz: "-1",
        Data: [],
        Numar: "",
      };
      this.refresh_info();
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right('Management')){
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  margin-right: 2%;
    width: 23%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
